module.exports = __webpack_public_path__ + "static/media/drBR.feae7777.png";